export class Role {
  id!: number;
  code!: string;
  label!: string;

  constructor(data = {}) {
    Object.assign(this, data);

    if(!this.label) {
      this.label = this.code;
    }
  }
}
